/* @flow */

import get from 'lodash/get';
import getFiltroIntervaloDia from '../../utils/data/get-filtro-intervalo-dia';
import gerarGraficoPorHoras from './gerar-grafico-por-horas';
import gerarGraficoPorDiaDaSemana from './gerar-grafico-por-dias-da-semana';
import gerarGraficoPorDias from './gerar-grafico-por-dias';
import loading from '../utils/loading';
import mostrarResultadoVazio from '../utils/mostrar-resultado-vazio';
import esconderGraficos from '../utils/esconder-graficos';
import mostrarGraficos from '../utils/mostrar-graficos';
import relatorios from '../relatorios';

import { type EtapasId } from '../../pedidos/types';
import { type Filtro } from '../types';

const criarVolumeDeVendas = (etapasId: EtapasId) => (filtro: Filtro = getFiltroIntervaloDia()) => {
    loading.show();
    filtro.etapasId = etapasId;

    relatorios.calcularVolumePedidos(filtro)
        .then(({ data }) => {
            if (!data.dias.length) {
                throw new Error();
            }

            mostrarGraficos();
            gerarGraficoPorHoras(data.horas);
            gerarGraficoPorDiaDaSemana(data.diaDaSemana);
            gerarGraficoPorDias(data.dias);
        })
        .catch((error) => {
            esconderGraficos();

            return mostrarResultadoVazio({
                id: 'container-graficos',
                msg: get(error, 'response.data.message', '<b>Não tem dados suficientes</b> para gerar os gráficos'),
            });
        }).then(() => {
            loading.hide();
        });
};

export default criarVolumeDeVendas;
